var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.toClients}},[_c('CRow',[_c('CCol',[_c('CWidgetProgressIcon',{staticStyle:{"height":"188px"},attrs:{"header":_vm.clientsCount,"text":"My Clients","color":"primary","value":100}},[_c('CIcon',{attrs:{"name":"cil-people","height":"36"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }